import { Component, EventEmitter, Input, Output, Optional, Host } from '@angular/core';
import { C4InputInterface, C4Input, C4InputConfig, C4Option } from '../c4-input';
import { C4Form } from '../c4-form';
import { C4OptionService } from '../c4-option-service';

@Component({
  selector: 'c4-input-list',
  templateUrl: 'c4-input-list.html',
  styles: [`
		.control-label {
			font-weight: normal;
		}
	`],
  providers: [C4OptionService]
})
export class C4InputList extends C4Input implements C4InputInterface {
  @Input() config;
  @Input() name: string;
  @Input() tagId: string;
  @Input() value: string;

  @Output() valueChange: EventEmitter<string> = new EventEmitter<string>();

  @Input() options: C4Option[];
  @Input() optionsUrl: string;
  @Input() optionKey: string;
  @Input() optionDisplay: string;

  constructor(
    private optionsService: C4OptionService,
    @Optional() @Host() form: C4Form
  ) {
    super(form);
    this.optionKey = this.optionKey || 'value';
    this.optionDisplay = this.optionDisplay || 'name';
  }

  init(model: C4Option, config: C4InputConfig) {
    super.init(model, config);

    this.options = model.values;
    this.optionsUrl = (model.valueSrc || { path: undefined }).path;
    this.optionKey = model.valueField || 'value';
    this.optionDisplay = model.valueDisplay || 'name';
    this.optionsService.hydrateOptions(this);
  }

  ngOnInit() {
    super.ngOnInit();
    this.optionsService.hydrateOptions(this);
  }
}



// WEBPACK FOOTER //
// ./~/@c4/ui/src/app/directives/input/list/c4-input-list.ts